import { useClaimDialog } from './logic/useClaimDialog'
import { ClaimView } from './views/ClaimView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface ClaimContainerProps {
  closeDialog: () => void
}

function ClaimDialogContentContainer({ closeDialog }: ClaimContainerProps) {
  const { txOverview, actionsViewState, pageStatus, reward } = useClaimDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="claimFarmRewards"
        tokenWithValue={reward}
        proceedText="Back to Farm"
        onProceed={closeDialog}
      />
    )
  }

  return <ClaimView actionsViewState={actionsViewState} txOverview={txOverview} />
}

const ClaimDialogContentContainerWithSuspense = withSuspense(ClaimDialogContentContainer, DialogContentSkeleton)
export { ClaimDialogContentContainerWithSuspense as ClaimDialogContentContainer }
